export const backendUrl = process.env.REACT_APP_CORE_BASE_URL;